export default __webpack_public_path__ + "static/media/element_24.fa8293b7.webp";